import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import { MoreVert, Edit, Delete, AttachFile } from '@mui/icons-material';
import { format, isPast } from 'date-fns';

const TaskCard = ({ task, onEdit, onDelete, onClick }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(task);
    handleMenuClose();
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(task);
    handleMenuClose();
  };

  const getPriorityColor = (priority) => {
    const colors = {
      low: 'success',
      medium: 'info',
      high: 'warning',
      urgent: 'error',
    };
    return colors[priority] || 'default';
  };

  const getStatusColor = (status) => {
    const colors = {
      todo: 'default',
      'in-progress': 'primary',
      review: 'warning',
      completed: 'success',
    };
    return colors[status] || 'default';
  };

  const isOverdue = isPast(new Date(task.deadline)) && task.status !== 'completed';

  return (
    <Card
      sx={{
        cursor: 'pointer',
        '&:hover': { boxShadow: 3 },
        borderLeft: isOverdue ? '4px solid #f44336' : 'none',
      }}
      onClick={() => onClick(task)}
    >
      <CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Typography variant="h6" component="div" gutterBottom>
            {task.title}
          </Typography>
          <IconButton size="small" onClick={handleMenuOpen}>
            <MoreVert />
          </IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <MenuItem onClick={handleEdit}>
              <Edit fontSize="small" sx={{ mr: 1 }} />
              Edit
            </MenuItem>
            <MenuItem onClick={handleDelete}>
              <Delete fontSize="small" sx={{ mr: 1 }} />
              Delete
            </MenuItem>
          </Menu>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }} noWrap>
          {task.description || 'No description'}
        </Typography>

        <Box display="flex" gap={1} flexWrap="wrap" mb={1}>
          <Chip label={task.priority} color={getPriorityColor(task.priority)} size="small" />
          <Chip label={task.status} color={getStatusColor(task.status)} size="small" />
          {task.attachments?.length > 0 && (
            <Chip
              icon={<AttachFile fontSize="small" />}
              label={task.attachments.length}
              size="small"
            />
          )}
        </Box>

        <Typography variant="caption" color={isOverdue ? 'error' : 'text.secondary'}>
          {isOverdue ? 'Overdue: ' : 'Due: '}
          {format(new Date(task.deadline), 'MMM dd, yyyy')}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default TaskCard;
